import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {
    IWastyIntermediary
} from "../../../../../../utils/interfaces/special_wasty/wasty_intermediary/IWastyIntermediary";


const useApiUpdateWastyIntermediary = (): UseMutationResult<IWastyIntermediary, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IWastyIntermediary> {
        try {
            const response = await put(`/api/company/${company_token}/special_wasty/wasty_intermediary/${pk}`, data);
            return response.data as IWastyIntermediary;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IWastyIntermediary, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetWastyIntermediary', data.id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetWastyIntermediaries']});
        },
    });
};


export default useApiUpdateWastyIntermediary;